import React from 'react';

export default function PhoneInput({ value, onChange, error, inputProps = {} }) {
  // Strip the +91 prefix for display - the user only sees / edits the
  // 10-digit national number; the +91 lives in the locked pill.
  const digits = (() => {
    const v = value || '';
    if (v.startsWith('+91')) return v.slice(3);
    // Tolerate legacy values that came in without the prefix.
    return v.replace(/\D/g, '').slice(0, 10);
  })();

  const handleChange = (e) => {
    const cleaned = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange('+91' + cleaned);
  };

  // Block non-digit keypresses outright so users get an obvious "no"
  // instead of silent stripping on every keystroke.
  const handleKeyDown = (e) => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const borderColor = error ? '#E63946' : 'rgba(212,181,116,0.2)';
  const { style: inputStyleOverride, ...restInputProps } = inputProps;

  return (
    <div style={{ display: 'flex', alignItems: 'stretch' }}>
      <span style={{
        padding: '10px 14px',
        background: '#1A1A1A',
        color: '#B79F6D',
        border: `1px solid ${borderColor}`,
        borderRight: 'none',
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: 0.5,
        userSelect: 'none',
        display: 'inline-flex',
        alignItems: 'center',
      }}>
        +91
      </span>
      <input
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={10}
        placeholder="9876543210"
        autoComplete="tel-national"
        {...restInputProps}
        value={digits}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        style={{
          flex: 1,
          padding: '10px 12px',
          background: '#0F0F0F',
          color: '#F7E8BF',
          border: `1px solid ${borderColor}`,
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
          fontSize: 14,
          outline: 'none',
          letterSpacing: 0.4,
          ...inputStyleOverride,
        }}
      />
    </div>
  );
}
